import { Box, Grid, Typography } from "@mui/material";

export default function InfoElement(props) {
  return (
    <Grid size={{ xs: 12, sm: 4 }}>
      <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", gap: 1}}>
        {<props.icon sx={{ fontSize: 60 }} />}
        <Typography variant="h3" sx={{
          textAlign: "center"
        }}>
          {props.title}
        </Typography>
        <Typography sx={{
          textAlign: "center"
        }}>
          {props.text}
        </Typography>
      </Box>
    </Grid>
  );
}